// @ts-nocheck
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@store/Framework/Common/GoogleAnalytics";

const mapOrderLineModel = (
    orderLine: OrderLineModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const {
        brand,
        description,
        id,
        isActiveProduct,
        productErpNumber,
        productId,
        qtyOrdered,
        shortDescription,
        unitListPrice,
        unitNetPrice,
        unitOfMeasure,
    } = orderLine;

    return {
        inactive: !isActiveProduct || undefined,
        item_brand: brand?.name,
        item_id: productErpNumber,
        item_name: shortDescription || description,
        price: ga.util.parseAmount(unitNetPrice),
        quantity: qtyOrdered ?? 1,
        unit_of_measure: unitOfMeasure || undefined,
        ...ga.util.getItemDiscountParameters(unitListPrice, unitNetPrice),
        ...ga.map.promotionsOption(options, id),
        ...ga.map.productInfosOption(options, productId),
        ...options?.itemData,
    };
};

export default mapOrderLineModel;
